import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as func from "../../../../../utils/functions";

import * as Actions from "../../../../../store/modules/scholars";
import * as FActions from "../../../../../store/modules/footer";

import EditInput from "../../../../etc/admin/input"

import InputBox from "../../../../etc/InputBox"
import SelectBox from "../../../../etc/SelectBox"

import NameForm from "../NameForm"
import IdForm from "../IdForm"
import { STATUS_NAME } from "../../../../../wpconfig";

class DefaultForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categoryType: ['sinbun_type', 'scholar_name_type', 'author_meta_type'],
      name_type: [],
      name_type_Name: [],
      author_meta_type: [],
      author_meta_type_Name: [],
      sinbun_type: [],
      sinbun_type_Name: [],
      field: "scholar_name_type",
      pkKey: "ID",
      dept: [],
      deptKeyLabel: {},
      dept_depth1: [],
      dept_depth2: [],
      dept_depth3: [],
      autoSearchFocus: '',
      autoSearchRecords: [],
      status: this.props.record.scholar_status
    }

    this.showMessage = this.showMessage.bind(this);
  }

  componentDidMount() {
    const { record, dataActions } = this.props;
    if (record && !record.is_working) {
      const updatedRecord = { ...record, is_working: 'y' };
      dataActions.setScholar({ "record": updatedRecord });
    }
    this.state.categoryType.map((type, idx) => {
      func.getData("code/search/" + type, {}).then((response) => {
        const t = {}
        t[type] = response.records;
        t[type + "_Name"] = {}
        response.records.map((r, i) => {
          t[type + "_Name"][r.code_id] = r.code_name;
        });
        this.setState(t);
      });
    })

    func.getData("category/dept", null).then((response) => {
      const deptKeyLabel = {}
      response.records.map((d, index) => {
        deptKeyLabel[d.category_id] = d.category_name
      })
      this.setState({
        dept: response.records,
        deptKeyLabel: deptKeyLabel
      }, () => {
        this.setDepth();
      })
    })
  }

  setDepth() {
    let depth1 = [];
    let depth2 = [];
    let depth3 = [];

    if (this.state.dept.length > 0) {
      depth1 = this.getChildDepth(0)

      if (this.props.record.col_id) { depth2 = this.getChildDepth(this.props.record.col_id) }
      if (this.props.record.dept_id) { depth3 = this.getChildDepth(this.props.record.dept_id) }

      this.setState({
        dept_depth1: depth1,
        dept_depth2: depth2,
        dept_depth3: depth3
      })
    }
  }

  getChildDepth(parent_id) {
    let returnData = this.state.dept.filter(f => f.up_category_id == parent_id);
    return returnData
  }

  onUpdate = () => {
    if (func.getParams("record_id")) {
      func.updateData("admin/scholar/" + func.getParams("record_id") + "/update", this.props.record).then((response) => {
        if (response.code === 'ok') {
          this.showMessage('저장 되었습니다.');
          this.setState({
            status: this.props.record.scholar_status
          })
        } else {
          this.showMessage('저장 실패 : ' + response.message)
        }
      })
    } else {
      func.updateData("admin/scholar/insert", this.props.record).then((response) => {
        if (response.code === 'ok') {
          this.showMessage('저장 되었습니다.');
          location.href = func.changeParamUrl('record_id', response.scholar_id);
        } else {
          this.showMessage('저장 실패 : ' + response.return_message.message)
        }
      })
    }
  }

  handleImageClick = () => {
    if (this.fileInput) {
      this.fileInput.click();
    }
  }

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // 파일 타입 검증
    if (!file.type.match('image.*')) {
      this.showMessage('이미지 파일만 업로드 가능합니다.');
      return;
    }

    // FormData 생성
    const formData = new FormData();
    formData.append('file', file);

    // 관리자 페이지인 경우 record_id 전달
    const recordId = func.getParams("record_id");
    if (recordId) {
      formData.append('record_id', recordId);
    }

    // 파일 업로드
    func.updateFile("my_library/photo", formData).then((response) => {
      if (response && response.code === 'success') {
        let record = this.props.record;
        record.profile_pic = response.image;
        this.props.dataActions.setScholar({ "record": record });
        this.showMessage('사진이 업로드 되었습니다.');
        this.forceUpdate();
      } else {
        this.showMessage('사진 업로드 실패 : ' + (response?.message || '알 수 없는 오류'))
      }
    }).catch((error) => {
      this.showMessage('사진 업로드 실패');
    });

    // input 초기화 (같은 파일을 다시 선택할 수 있도록)
    event.target.value = '';
  }

  useConfirm = (message = null, onConfirm, onCancel) => {
    if (!onConfirm || typeof onConfirm !== "function") {
      return;
    }
    if (onCancel && typeof onCancel !== "function") {
      return;
    }

    if (window.confirm(message)) {
      onConfirm();
    } else {
      onCancel();
    }
  }

  onDelete = () => {
    func.getParams("record_id") ? (
      this.useConfirm("삭제하시겠습니까?", this.deleteConfirm, this.cancelConfirm)
    ) : (
      console.log("레코드 아이디가 없으면 삭제 불가능")
    )
  }

  deleteConfirm = () => {
    func.updateData("admin/scholar/" + func.getParams("record_id") + "/delete", this.props.record).then((response) => {
      if (response.code === 'ok') {
        this.showMessage('삭제 되었습니다.');
        this.goLists()
      } else {
        this.showMessage('삭제 실패 : ' + response.message)
      }
    })
  }

  cancelConfirm = () => this.showMessage('취소 되었습니다.');

  showMessage(message) {
    this.props.fDataActions.setFooter({
      'isNoticePopup': true,
      'noticeMessage': message
    })
    setTimeout(() => {
      this.props.fDataActions.setFooter({
        'isNoticePopup': false,
        'noticeMessage': ''
      })
    }, 3000);
  }

  goLists = () => {
    const url = func.removeParamUrl('record_id')
    location.replace(url);
  }

  onChange = (e) => {
    let record = this.props.record;
    record[e.target.name] = e.target.value;
    if (e.target.name === 'sinbun_code') {
      this.state.sinbun_type.map((type, i) => {
        if (e.target.value == type.code_id) {
          record['sinbun_name'] = type.code_name
        }
      })
    }
    // let oldValue = record.sinbun_type.filter(f => f.sinbun_code == e.target.name)[0].sinbun_status
    // record.sinbun_type.filter(f => f.sinbun_code == e.target.name)[0].sinbun_status = oldValue == "Y" ? "N" : "Y"
    this.props.dataActions.setScholar({ "record": record });
    this.forceUpdate()
  };

  textEvent = (event) => {
    let record = this.props.record;
    record[event.target.name] = event.target.value;

    if (event.target.name == "col_id") {
      record.col_name = this.state.deptKeyLabel[event.target.value]
      record.dept_id = "";
      record.maj_id = "";
    } else if (event.target.name == "dept_id") {
      record.dept_name = this.state.deptKeyLabel[event.target.value]
      record.maj_id = "";
    } else if (event.target.name == "maj_id") {
      record.maj_name = this.state.deptKeyLabel[event.target.value]
    }

    this.setDepth()

    this.props.dataActions.setScholar({ "record": record });
    this.forceUpdate()
  }

  onKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      // this.search()
    }
  }

  autoSearchText = (event) => {
    let record = this.props.record;
    let el = event.target.name;
    let keyword = event.target.value;
    let autoRecords;

    record[el] = keyword;

    switch (el) {
      case "col_name":
        record.dept_id = "";
        record.maj_id = "";
        autoRecords = this.state.dept_depth1.filter(f => f.category_name.includes(keyword));
        break;
      case "dept_name":
        record.maj_id = "";
        autoRecords = this.state.dept_depth2.filter(f => f.category_name.includes(keyword));
        break;
      case "maj_name":
        autoRecords = this.state.dept_depth3.filter(f => f.category_name.includes(keyword));
        break;
    }

    this.setDepth();

    this.setState({
      autoSearchFocus: el,
      autoSearchRecords: autoRecords
    })

    this.props.dataActions.setScholar({ "record": record });
  }

  setInfo(type, item) {
    let record = this.props.record;
    if (type === 'col') {
      record.col_id = item.category_id;
      record.col_name = item.category_name;
      record.dept_id = '';
      record.dept_name = '';
      record.maj_id = '';
      record.maj_name = '';
    } else if (type === 'dept') {
      record.dept_id = item.category_id;
      record.dept_name = item.category_name;
      record.maj_id = '';
      record.maj_name = '';
    } else if (type === 'maj') {
      record.maj_id = item.category_id;
      record.maj_name = item.category_name;
    }

    this.setDepth();

    this.props.dataActions.setScholar({ "record": record });

    this.setState({
      autoSearchFocus: '',
      autoSearchRecords: [],
    })
  }

  // textEvent = (event) => {
  // 	let record = this.props.record;
  // 	record[event.target.name] = event.target.value;
  // 	this.props.dataActions.setScholar({"record": record});
  // }

  render() {
    const { onChange, textEvent, autoSearchText } = this
    const { record } = this.props

    return (
      <>
        <div className="d-flex mt-4 mb-1">
          <h5 className="mr-auto">기본 정보</h5>
          <select className="form-control mr-3"
            name="scholar_status" onChange={this.onChange}
            style={{ width: "100px", height: '32px' }}
            value={record.scholar_status || 'publish'}>
            {Object.keys(STATUS_NAME).map((item, index) => {
              if (this.state.status !== 'trash' && item === 'delete')
                return ''
              return (<option key={index} value={item}>{STATUS_NAME[item]}</option>)
            })}
          </select>
          <button className="btn btn-sm btn-primary order-0" type="button" id="save_scholar" onClick={this.onUpdate}>저장</button>
          {this.state.status === 'trash' &&
            <button className="btn btn-sm btn-danger order-1 ml-2" type="button" id="delete_scholar" onClick={this.onDelete}>삭제</button>
          }
          <button className="btn btn-sm btn-secondary order-1 ml-2" type="button" id="show_list" onClick={this.goLists}>리스트</button>
        </div>
        <form className="mt-4">
          <div className="row mb-2">
            <div className="col-md-2 form-group">
              <figure className="figure scholarPicture">
                <img
                  src={record.profile_pic || "https://lib.pusan.ac.kr/star/wp-content/themes/rm-space/extend/framework//assets/images/user_picture.png"}
                  className="w-100 figure-img img-fluid rounded"
                  alt="사진"
                  onClick={this.handleImageClick}
                  style={{ cursor: 'pointer' }}
                />
                <input
                  type="file"
                  ref={(ref) => this.fileInput = ref}
                  onChange={this.handleFileChange}
                  accept="image/jpeg, image/jpg, image/png, image/gif"
                  style={{ display: 'none' }}
                />
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary mt-2 w-100"
                  onClick={this.handleImageClick}
                >
                  사진 변경
                </button>
              </figure>
            </div>
            <div className="col-md-10 form-group">
              <div className="row mb-2 maxWidthInit">
                <div className="col-md-3">
                  <EditInput
                    title="이름(대표)-논문에 표시"
                    value={record.scholar_name}
                    name="scholar_name"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-3">
                  <EditInput
                    title="한글명(Display)"
                    value={record.scholar_name_kor}
                    name="scholar_name_kor"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-3">
                  <EditInput
                    title="영문명(Display)"
                    value={record.scholar_name_eng}
                    name="scholar_name_eng"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-3">
                  <div className="form-group"><label><strong>신분</strong></label>
                    <div>
                      <select className="form-control form-control-sm"
                        value={record.sinbun_code || ""}
                        ref={(ref) => this.sinbun_code = ref}
                        name="sinbun_code"
                        onChange={this.onChange}>
                        <option value="">선택해주세요.</option>
                        {this.state.sinbun_type.map((type, i) => {
                          return (<option key={type.code_id} value={type.code_id}>{type.code_name}</option>)
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <NameForm />
              </div>

              <div className="row mb-2">
                <div className="col-md-4">
                  <label htmlFor="input"><strong>단과대학</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="col_name"
                      className="form-control"
                      ref={(ref) => this.col_name = ref}
                      value={record.col_name || ""}
                      onFocus={autoSearchText}
                      onChange={autoSearchText}
                      onKeyDown={this.onKeyDown}
                    />
                    {this.state.autoSearchFocus === 'col_name' &&
                      <div className="auto-search-dropdown">
                        {this.state.autoSearchRecords.length < 1 && (<label>단대 목록이 없습니다.</label>)}
                        {this.state.autoSearchRecords.map((item, index) => {
                          return (<label key={index} onClick={() => this.setInfo('col', item)}>{item.category_name}</label>)
                        })}
                      </div>
                    }
                  </div>
                </div>
                <div className="col-md-4">
                  <label htmlFor="input"><strong>학과</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="dept_name"
                      className="form-control"
                      ref={(ref) => this.dept_name = ref}
                      value={record.dept_name || ""}
                      onFocus={autoSearchText}
                      onChange={autoSearchText}
                      onKeyDown={this.onKeyDown}
                    />
                    {this.state.autoSearchFocus === 'dept_name' &&
                      <div className="auto-search-dropdown">
                        {this.state.autoSearchRecords.length < 1 && (<label>하위 학과가 없습니다.</label>)}
                        {this.state.autoSearchRecords.map((item, index) => {
                          return (<label key={index} onClick={() => this.setInfo('dept', item)}>{item.category_name}</label>)
                        })}
                      </div>
                    }
                  </div>
                </div>
                <div className="col-md-4">
                  <label htmlFor="input"><strong>전공</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="maj_name"
                      className="form-control"
                      ref={(ref) => this.maj_name = ref}
                      value={record.maj_name || ""}
                      onFocus={autoSearchText}
                      onChange={autoSearchText}
                      onKeyDown={this.onKeyDown}
                    />
                    {this.state.autoSearchFocus === 'maj_name' &&
                      <div className="auto-search-dropdown">
                        {this.state.autoSearchRecords.length < 1 && (<label>하위 전공이 없습니다.</label>)}
                        {this.state.autoSearchRecords.map((item, index) => {
                          return (<label key={index} onClick={() => this.setInfo('maj', item)}>{item.category_name}</label>)
                        })}
                      </div>
                    }
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-2">
                  <label htmlFor="input"><strong>재직여부</strong></label>
                  <div className="mt-1">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_working"
                        id="is_working_y"
                        value="y"
                        checked={record.is_working === 'y' || !record.is_working}
                        onChange={this.onChange}
                      />
                      <label className="form-check-label" htmlFor="is_working_y">재직</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="is_working"
                        id="is_working_n"
                        value="n"
                        checked={record.is_working === 'n'}
                        onChange={this.onChange}
                      />
                      <label className="form-check-label" htmlFor="is_working_n">퇴직</label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <EditInput
                    title="임용일(2002-01-01)"
                    value={record.working_start}
                    name="working_start"
                    onKeyUp={onChange}
                  />
                </div>
                <div className="col-md-3">
                  <EditInput
                    title="퇴직일(2002-01-01)"
                    value={record.working_end}
                    name="working_end"
                    onKeyUp={onChange}
                  />
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-2">
                  <EditInput
                    title="교직원 번호(학번)"
                    value={record.school_no}
                    name="school_no"
                    onKeyUp={onChange}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor="input"><strong>Researcher ID(WoS)</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="researcher_id"
                      className="form-control"
                      ref={(ref) => this.researcher_id = ref}
                      value={record.researcher_id || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("http://www.researcherid.com/rid/" + record.researcher_id, '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <label htmlFor="input"><strong>Scopus ID</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="scopus_id"
                      className="form-control"
                      ref={(ref) => this.scopus_id = ref}
                      value={record.scopus_id || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("#", '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="input"><strong>KCI ID</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="kci_id"
                      className="form-control"
                      ref={(ref) => this.kci_id = ref}
                      value={record.kci_id || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("#", '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <label htmlFor="input"><strong>KRI ID</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="kri_id"
                      className="form-control"
                      ref={(ref) => this.kri_id = ref}
                      value={record.kri_id || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("#", '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3">
                  <label htmlFor="input"><strong>ORCID</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="orcid"
                      className="form-control"
                      ref={(ref) => this.orcid = ref}
                      value={record.orcid || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("#", '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="input"><strong>ResearchGate ID</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="researchgate_id"
                      className="form-control"
                      ref={(ref) => this.researchgate_id = ref}
                      value={record.researchgate_id || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("#", '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="input"><strong>ISNI</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="isni"
                      className="form-control"
                      ref={(ref) => this.isni = ref}
                      value={record.isni || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("#", '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <label htmlFor="input"><strong>GoogleScholar ID</strong></label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="googlescholar_id"
                      className="form-control"
                      ref={(ref) => this.googlescholar_id = ref}
                      value={record.googlescholar_id || ""}
                      onChange={textEvent}
                    />
                    <div className="input-group-prepend">
                      <div className="input-group-text search-scholar">
                        <a href="#" onClick={() => window.open("#", '_blank')}>
                          <span className="link-icon align-middle"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <IdForm />
              </div>
              <div className="row mb-2">
                <div className="col-md-12">
                  <EditInput
                    title="연구자 확인용 핫포인트"
                    value={record.hotpoint}
                    name="hotpoint"
                    onKeyUp={textEvent}
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-md-3">
                  <EditInput
                    title="E-mail"
                    value={record.email}
                    name="email"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-3">
                  <EditInput
                    title="홈페이지"
                    value={record.homepage}
                    name="homepage"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-3">
                  <EditInput
                    title="연구실 위치"
                    value={record.lab_name}
                    name="lab_name"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor=""><strong>외부 공동저자 메일발송</strong></label>
                  <div className="mt-1">
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="sendmail_co" id="sendmail_co_yes" value="Y"
                        checked={record.sendmail_co !== 'N'} onChange={this.onChange} />
                      <label className="form-check-label" htmlFor="sendmail_co_yes">허용</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" name="sendmail_co" id="sendmail_co_no" value="N"
                        checked={record.sendmail_co === 'N'} onChange={this.onChange} />
                      <label className="form-check-label" htmlFor="sendmail_co_no">거부</label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <EditInput
                  title="연구 분야"
                  value={record.research_field}
                  name="research_field"
                  onKeyUp={textEvent}
                />
              </div>

              <div className="mb-3">
                <EditInput
                  title="희망협업분야"
                  value={record.collabo_field}
                  name="collabo_field"
                  onKeyUp={textEvent}
                />
              </div>

              <div className="row mb-2">
                <div className="col-md-3">
                  <EditInput
                    title="지도 교수"
                    value={record.advisor_name}
                    name="advisor_name"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-3">
                  <EditInput
                    title="국적"
                    value={record.nationality}
                    name="nationality"
                    onKeyUp={textEvent}
                  />
                </div>
                <div className="col-md-6">
                  <EditInput
                    title="BK21"
                    // value={ record.nationality }
                    // name="nationality"
                    onKeyUp={textEvent}
                  />
                </div>
              </div>

              <div className="mb-3 mt-2">
                <div className="form-group"><label><strong>소개글</strong></label>
                  <div>
                    <textarea className="form-control" defaultValue={record.introduction || ''}
                              name="introduction"
                              onChange={this.textEvent}
                              placeholder=""
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <div className="form-group"><label><strong>학력</strong></label>
                  <div>
                    <textarea className="form-control" defaultValue={record.education || ''}
                              name="education"
                              onChange={this.textEvent}
                              placeholder=""
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <div className="form-group"><label><strong>경력</strong></label>
                  <div>
                    <textarea className="form-control" defaultValue={record.career || ''}
                              name="career"
                              onChange={this.textEvent}
                              placeholder=""
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </form>
      </>
    )
  }
}

export default connect(
  (state) => ({
    record: state.scholars.record ? state.scholars.record : {
      'scholar_status': 'publish'
    },
  }),
  (dispatch) => ({
    dataActions: bindActionCreators(Actions, dispatch),
    fDataActions: bindActionCreators(FActions, dispatch)
  }),
)(DefaultForm)
